/* Zero Treat — theme interactions (all features guard for missing sections) */
(function () {
  const P = window.ZT_PRODUCTS || [], X = window.ZT_EXTRAS || [], CFG = window.ZT_CONFIG || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = n => (CFG.currency || "$") + n.toFixed(2);
  const moneyCents = c => money(c / 100);
  const bySlug = s => P.find(p => p.slug === s) || X.find(p => p.slug === s);
  const byVariant = id => P.find(p => p.variantId === id) || X.find(p => p.variantId === id);
  const STAR = `<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.6 7.1.7-5.4 4.8 1.6 7-6.2-3.7-6.2 3.7 1.6-7L2 9.3l7.1-.7z"/></svg>`;
  const LEAF = `<svg class="leaf" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20 4c-8 0-14 4-15 12 0 0 5 4 10 2C22 15 20 4 20 4zM5 20c2-6 7-9 11-10-5 4-8 7-9 10H5z"/></svg>`;

  /* ---------- header chrome ---------- */
  const header = $("#siteHeader");
  if (header) addEventListener("scroll", () => header.classList.toggle("scrolled", scrollY > 8), { passive: true });

  const mobileNav = $("#mobileNav"), scrim = $("#scrim");
  const navOpen = o => {
    if (!mobileNav || !scrim) return;
    mobileNav.classList.toggle("open", o); scrim.classList.toggle("show", o);
    document.body.style.overflow = o ? "hidden" : "";
  };
  if ($("#burgerBtn")) $("#burgerBtn").onclick = () => navOpen(true);
  if ($("#closeNav")) $("#closeNav").onclick = () => navOpen(false);
  if (mobileNav) $$("#mobileNav a").forEach(a => a.addEventListener("click", e => {
    const href = a.getAttribute("href") || "";
    const hi = href.indexOf("#");
    const hash = hi > -1 ? href.slice(hi) : "";
    const target = hash.length > 1 ? document.querySelector(hash) : null;
    navOpen(false);                   /* always close the menu first */
    if (target) {                     /* same-page section: scroll after the menu closes (iOS-safe) */
      e.preventDefault();
      setTimeout(() => {
        const head = document.getElementById("siteHeader");
        const off = (head ? head.offsetHeight : 0) + 16;
        const y = target.getBoundingClientRect().top + window.pageYOffset - off;
        window.scrollTo({ top: y, behavior: "smooth" });
      }, 320);
    }
  }));

  const langBox = $("#langBox");
  if (langBox) {
    $("#langBtn").onclick = e => { e.stopPropagation(); langBox.classList.toggle("open"); };
    addEventListener("click", () => langBox.classList.remove("open"));
  }

  /* ---------- reveal on scroll ---------- */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
  }), { threshold: 0.12 });
  $$("[data-reveal]").forEach(el => io.observe(el));

  /* ---------- hero parallax ---------- */
  const heroPhoto = $("#heroPhoto");
  if (heroPhoto && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    addEventListener("scroll", () => {
      const y = Math.min(scrollY, 700);
      heroPhoto.style.transform = `translateY(${y * 0.12}px)`;
    }, { passive: true });
  }

  /* ---------- benefit ribbon: words ride the hero's exit wave ----------
     The sine below is phase-matched to the SVG path in benefit-ribbon.liquid:
     one cycle per viewport width, crest at 1/4 and trough at 3/4, so the text
     rises and falls exactly parallel to the curve above it at any screen size.
     The phrase sequence repeats until one half of the track out-measures the
     viewport, so the band never shows a gap or a half-finished phrase. */
  const rTrack = document.getElementById("ribbonTrack");
  const rWave = document.querySelector(".ribbon-wave");
  if (rTrack && rTrack.children.length) {
    const rUnit = Array.prototype.slice.call(rTrack.children).map(n => n.cloneNode(true));
    const rReduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    const NBSP = String.fromCharCode(160);
    let rLetters = [], rBase = [], rHalf = 1, rAmp = 10;

    const rFill = (copies) => {
      rTrack.textContent = "";
      for (let c = 0; c < copies; c++) rUnit.forEach(n => rTrack.appendChild(n.cloneNode(true)));
    };

    const rLayout = () => {
      rFill(1);
      const unitW = rTrack.scrollWidth || 1;
      const per = Math.max(1, Math.ceil((rVW() + 80) / unitW));
      rFill(per * 2);

      rLetters = [];
      Array.prototype.slice.call(rTrack.children).forEach(wordEl => {
        const text = wordEl.textContent;
        wordEl.textContent = "";
        for (let i = 0; i < text.length; i++) {
          const ch = text.charAt(i);
          const el = document.createElement("i");
          el.textContent = (ch === " ") ? NBSP : ch;
          wordEl.appendChild(el);
          rLetters.push(el);
        }
      });
      rBase = rLetters.map(l => l.offsetLeft + l.offsetWidth / 2);
      rHalf = rTrack.scrollWidth / 2 || 1;
      const waveH = rWave ? rWave.getBoundingClientRect().height : 48;
      // swings a little wider than the curve above it so the rise and fall
      // stays legible across a broad, single-cycle wave
      rAmp = Math.max(10, Math.min(34, waveH * 0.45));
    };

    // a hidden or not-yet-sized tab can report 0 width, which would collapse the
    // wavelength and fling the letters on their side — floor it at a sane width
    const rVW = () => Math.max(320, window.innerWidth || 0);

    const rPaint = (x) => {
      rTrack.style.transform = "translateX(" + (-x) + "px)";
      const k = 2 * Math.PI / rVW();
      for (let i = 0; i < rLetters.length; i++) {
        const sx = rBase[i] - x;
        const y = -rAmp * Math.sin(k * sx);
        const rot = Math.atan(-rAmp * k * Math.cos(k * sx)) * 180 / Math.PI;
        rLetters[i].style.transform = "translateY(" + y.toFixed(1) + "px) rotate(" + rot.toFixed(2) + "deg)";
      }
    };

    let rX = 0;
    rLayout(); rPaint(0);

    let rT;
    addEventListener("resize", () => {
      clearTimeout(rT);
      rT = setTimeout(() => { rLayout(); rX = rX % rHalf; rPaint(rX); }, 160);
    });

    // the display face changes every letter's width, so re-measure once it lands
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => { rLayout(); rX = rX % rHalf; rPaint(rX); });
    }

    if (!rReduce) {
      const SPEED = 38;
      let rPrev = performance.now();
      (function waveLoop(now) {
        requestAnimationFrame(waveLoop);
        const dt = Math.min((now - rPrev) / 1000, .05); rPrev = now;
        rX = (rX + SPEED * dt) % rHalf;
        rPaint(rX);
      })(rPrev);
    }
  }

  /* ---------- how-to-use flip cards ---------- */
  $$(".use-card.flip").forEach(card => {
    card.setAttribute("role", "button");
    card.setAttribute("tabindex", "0");
    const flip = () => card.classList.toggle("flipped");
    card.addEventListener("click", flip);
    card.addEventListener("keydown", e => {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); flip(); }
    });
  });

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(text) {
    const t = $("#toast"); if (!t) return;
    t.innerHTML = `${LEAF} ${text}`;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("show"), 2400);
  }

  /* ---------- Shopify AJAX cart ---------- */
  const drawer = $("#cartDrawer");
  const openCart = o => {
    if (!drawer || !scrim) return;
    drawer.classList.toggle("open", o); scrim.classList.toggle("show", o);
    document.body.style.overflow = o ? "hidden" : "";
  };
  if ($("#cartBtn")) $("#cartBtn").onclick = () => { refreshCart(); openCart(true); };
  if ($("#closeCart")) $("#closeCart").onclick = () => openCart(false);
  if (scrim) scrim.onclick = () => { openCart(false); navOpen(false); };

  function badgeBump() {
    const b = $("#cartCount"); if (!b) return;
    b.classList.remove("bump"); void b.offsetWidth; b.classList.add("bump");
  }

  function renderCart(cart) {
    const box = $("#cartItems");
    const badge = $("#cartCount");
    if (badge) { badge.hidden = cart.item_count === 0; badge.textContent = cart.item_count; }
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = `<div class="cart-empty"><span class="hand">your cart is feeling empty…</span>Add a sauce or two — zero guilt, remember?</div>`;
    } else {
      box.innerHTML = cart.items.map((it, i) => `<div class="cart-item">
        <div class="ci-img">${it.image ? `<img src="${it.image}" alt="">` : ""}</div>
        <div><b>${it.product_title}</b><small>${moneyCents(it.final_price)}</small>
          <div class="qty-ctrl"><button data-q="${i + 1}:${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button data-q="${i + 1}:${it.quantity + 1}" aria-label="Increase">+</button></div>
        </div>
        <div class="ci-right"><span class="ci-price">${moneyCents(it.final_line_price)}</span><button class="ci-remove" data-q="${i + 1}:0">remove</button></div>
      </div>`).join("");
    }
    const total = cart.items_subtotal_price;
    if ($("#cartTotal")) $("#cartTotal").textContent = moneyCents(total);
    const wa = $("#waCheckout");
    if (wa && CFG.whatsapp) {
      const lines = cart.items.map(it => `• ${it.quantity}× ${it.product_title} — ${moneyCents(it.final_line_price)}`);
      const msg = encodeURIComponent(`Hi Zero Treat! I'd like to order:\n${lines.join("\n")}\n\nTotal: ${moneyCents(total)}`);
      wa.href = `https://wa.me/${CFG.whatsapp}?text=${msg}`;
      wa.style.display = cart.items.length ? "" : "none";
    }
  }

  function refreshCart() {
    return fetch("/cart.js").then(r => r.json()).then(renderCart).catch(() => {});
  }

  function addItems(items, note) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items })
    }).then(r => {
      if (!r.ok) return r.json().then(e => { throw new Error(e.description || "Couldn't add to cart"); });
      return r.json();
    }).then(res => {
      refreshCart();
      badgeBump();
      const first = res.items ? res.items[0] : res;
      toast(note || `${first.product_title} added to cart`);
    }).catch(err => toast(err.message));
  }

  const addToCart = (variantId, qty = 1, note) => addItems([{ id: variantId, quantity: qty }], note);

  function changeLine(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line, quantity })
    }).then(r => r.json()).then(renderCart).catch(() => {});
  }

  document.addEventListener("click", e => {
    const add = e.target.closest("[data-add]");
    if (add) { addToCart(+add.dataset.add); return; }
    const q = e.target.closest("[data-q]");
    if (q) {
      const [line, quantity] = q.dataset.q.split(":").map(Number);
      changeLine(line, quantity);
    }
  });

  /* ---------- carousels: arrows + drag ---------- */
  function railCtl(rail, prev, next) {
    if (!rail || !rail.querySelector(".p-card")) return;
    const step = () => rail.querySelector(".p-card").offsetWidth + 21;
    if (prev) prev.onclick = () => rail.scrollBy({ left: -step() * 2, behavior: "smooth" });
    if (next) next.onclick = () => rail.scrollBy({ left: step() * 2, behavior: "smooth" });
    let down = false, sx = 0, sl = 0, moved = false;
    rail.addEventListener("pointerdown", e => { down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; });
    addEventListener("pointermove", e => {
      if (!down) return;
      if (Math.abs(e.clientX - sx) > 6) { moved = true; rail.classList.add("dragging"); }
      if (moved) rail.scrollLeft = sl - (e.clientX - sx);
    });
    addEventListener("pointerup", () => { down = false; rail.classList.remove("dragging"); });
    rail.addEventListener("click", e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
  const car = $("#carousel");
  railCtl(car, $("#carPrev"), $("#carNext"));
  railCtl($("#extrasRail"), null, null);
  railCtl($("#relatedRail"), null, null);

  /* category "shop sweet/savory": scroll carousel to first matching card */
  $$("[data-filter]").forEach(b => b.addEventListener("click", () => {
    if (!car) return;
    const want = b.dataset.filter;
    setTimeout(() => {
      const first = car.querySelector(`.p-card[data-cat="${want}"]`);
      if (first) car.scrollTo({ left: first.offsetLeft - car.offsetLeft, behavior: "smooth" });
    }, 350);
  }));

  /* ---------- 3D stage ---------- */
  const stage = $("#stage"), stageWrap = $("#stageWrap"), bottleImg = $("#stageBottle"), blob = $("#stageBlob");
  if (stage && P.length) {
    const preferred = ["chocolate", "strawberry", "salted-caramel", "ketchup", "bbq"];
    let flavors = preferred.map(bySlug).filter(Boolean);
    if (flavors.length < 5) flavors = flavors.concat(P.filter(p => !flavors.includes(p))).slice(0, 5);
    const sw = $("#flavorSwitch");
    if (sw) {
      sw.innerHTML = flavors.map((p, i) =>
        `<button class="flavor-chip ${i === 0 ? "active" : ""}" data-flavor="${p.slug}"><span class="dot" style="background:${p.accent}"></span>${p.name.replace(" Sauce", "")}</button>`).join("");
      sw.addEventListener("click", e => {
        const chip = e.target.closest(".flavor-chip"); if (!chip) return;
        $$(".flavor-chip", sw).forEach(c => c.classList.toggle("active", c === chip));
        const p = bySlug(chip.dataset.flavor);
        bottleImg.style.opacity = 0;
        setTimeout(() => { bottleImg.src = p.img; bottleImg.alt = `Zero Treat ${p.name} bottle`; bottleImg.style.opacity = 1; }, 300);
        if (blob) blob.style.setProperty("--stage-accent", p.accent);
      });
    }
    if (flavors[0]) {
      bottleImg.src = flavors[0].img;
      if (blob) blob.style.setProperty("--stage-accent", flavors[0].accent);
    }

    let targetRX = 0, targetRY = 0, curRX = 0, curRY = 0, scrollRot = 0;
    stageWrap.addEventListener("pointermove", e => {
      const r = stageWrap.getBoundingClientRect();
      targetRY = ((e.clientX - r.left) / r.width - .5) * 26;
      targetRX = -((e.clientY - r.top) / r.height - .5) * 14;
    });
    stageWrap.addEventListener("pointerleave", () => { targetRX = 0; targetRY = 0; });
    const stageIO = new IntersectionObserver(es => es.forEach(e => {
      stageWrap.classList.toggle("in", e.isIntersecting);
    }), { threshold: .35 });
    stageIO.observe(stageWrap);
    addEventListener("scroll", () => {
      const r = stageWrap.getBoundingClientRect();
      const prog = 1 - Math.min(Math.max((r.top + r.height / 2) / innerHeight, 0), 1);
      scrollRot = (prog - .5) * 14;
    }, { passive: true });
    (function tiltLoop() {
      curRX += (targetRX - curRX) * .08;
      curRY += (targetRY + scrollRot - curRY) * .08;
      stage.style.transform = `rotateX(${curRX}deg) rotateY(${curRY}deg)`;
      requestAnimationFrame(tiltLoop);
    })();
  }

  /* ---------- quiz ---------- */
  const quizCard = $("#quizCard");
  if (quizCard && P.length) {
    const answers = [];
    const steps = $$(".quiz-step");
    const dots = $$("#quizProgress i");
    $$(".quiz-opt").forEach(btn => btn.addEventListener("click", () => {
      const stepEl = btn.closest(".quiz-step");
      const idx = +stepEl.dataset.step;
      answers[idx] = btn.dataset.a;
      dots[idx].classList.add("done");
      if (idx < steps.length - 1) {
        stepEl.classList.remove("active");
        steps[idx + 1].classList.add("active");
      } else {
        stepEl.classList.remove("active");
        showQuizResult();
      }
    }));
    function scoreProduct(p) {
      let s = 0;
      const [taste, use, goal] = answers;
      if (taste === "both" || p.cat === taste) s += 4;
      if (p.tags.includes(use)) s += 3;
      if (use === "drizzle" && p.cat === "sweet") s += 1;
      if (use === "cook" && p.cat === "savory") s += 1;
      if (goal === "lowcal" && p.nutrition.kcal.startsWith("2")) s += 2;
      if (goal === "bold" && ["bbq", "hot-ketchup", "sweet-chilli", "chocolate", "cinnamon-glaze"].includes(p.slug)) s += 2;
      if (goal === "everyday" && p.tags.includes("bestseller")) s += 2;
      return s + p.rating / 10;
    }
    function showQuizResult() {
      const top = [...P].sort((a, b) => scoreProduct(b) - scoreProduct(a)).slice(0, answers[0] === "both" ? 3 : 2);
      $("#quizVerdict").textContent = answers[0] === "both" ? "You need the mixed shelf:" : `Meet your new ${answers[0]} obsession:`;
      $("#quizPicks").innerHTML = top.map(p => `
        <div class="quiz-pick" style="--pk:${p.accent}">
          <img src="${p.img}" alt="${p.name}">
          <b>${p.name}</b>
          <span class="stars">${STAR} ${p.rating}</span>
          <button class="btn btn-primary btn-sm" data-add="${p.variantId}">Add · ${money(p.price)}</button>
        </div>`).join("");
      $("#quizResult").classList.add("active");
    }
    $("#quizRestart").onclick = () => {
      answers.length = 0;
      $("#quizResult").classList.remove("active");
      dots.forEach(d => d.classList.remove("done"));
      steps.forEach((s, i) => s.classList.toggle("active", i === 0));
    };
  }

  /* ---------- bundle builder ---------- */
  const bundlePicksEl = $("#bundlePicks");
  if (bundlePicksEl && P.length) {
    let tier = 3, picks = [];
    const tiers = CFG.bundleTiers || { 2: .10, 3: .15, 4: .20 };
    const tierNames = { 2: "duo · starter", 3: "trio · best seller", 4: "quad · best value" };
    bundlePicksEl.innerHTML = P.map(p => `
      <button class="b-chip" data-pick="${p.slug}">
        <span class="b-qty"></span>
        <img src="${p.img}" alt="${p.name}"><b>${p.name.replace(" Sauce", "")}</b>
      </button>`).join("");

    $("#tierSwitch").addEventListener("click", e => {
      const b = e.target.closest(".tier-btn"); if (!b) return;
      tier = +b.dataset.tier;
      $$(".tier-btn").forEach(x => x.classList.toggle("active", x === b));
      picks = picks.slice(0, tier);
      renderBundle();
    });
    bundlePicksEl.addEventListener("click", e => {
      const chip = e.target.closest(".b-chip"); if (!chip) return;
      if (picks.length >= tier) picks.shift(); /* oldest pick rolls out — keeps play fluid */
      picks.push(chip.dataset.pick);
      renderBundle();
    });

    function renderBundle() {
      const disc = tiers[tier];
      $("#bundleTierLabel").textContent = `${tier} bottles · ${tierNames[tier]}`;
      $$(".b-chip").forEach(c => {
        const n = picks.filter(s => s === c.dataset.pick).length;
        c.classList.toggle("picked", n > 0);
        c.querySelector(".b-qty").textContent = n > 1 ? `×${n}` : "";
      });
      $("#bundleSlots").innerHTML = Array.from({ length: tier }, (_, i) => {
        const s = picks[i];
        return s
          ? `<div class="b-slot" data-slot="${i}"><img src="${bySlug(s).img}" alt="${bySlug(s).name}"><span class="slot-x">✕</span></div>`
          : `<div class="b-slot"><span style="opacity:.35;font-size:1.6rem">+</span></div>`;
      }).join("");
      $$("#bundleSlots .b-slot[data-slot]").forEach(sl => sl.onclick = () => { picks.splice(+sl.dataset.slot, 1); renderBundle(); });
      const full = picks.map(bySlug).reduce((a, p) => a + p.price, 0);
      const total = full * (1 - disc);
      $("#bundleMath").innerHTML = `
        <div class="row"><span>${picks.length}/${tier} bottles picked</span><span>${money(full)}</span></div>
        <div class="row save"><span>Box discount (−${disc * 100}%)</span><span>−${money(full * disc)}</span></div>
        <div class="row total"><span>Box total</span><span>${money(total)}</span></div>
        <div class="row" style="opacity:.65"><span>discount applies at checkout</span><span></span></div>`;
      const ready = picks.length === tier;
      $("#bundleAdd").disabled = !ready;
      $("#bundleHint").textContent = ready ? "nice picks — that's a good box." : `pick ${tier - picks.length} more flavor${tier - picks.length > 1 ? "s" : ""} to fill your box ↑`;
    }
    $("#bundleAdd").onclick = () => {
      const items = picks.map(s => ({ id: bySlug(s).variantId, quantity: 1 }));
      try { localStorage.setItem("zt-box-tier", tier); } catch (e) {}
      addItems(items, "Your Zero Treat Box is in the cart — box discount applies at checkout").then(() => openCart(true));
      picks = []; renderBundle();
    };
    renderBundle();
  }

  /* box discount: route checkout through the matching discount code */
  const checkoutBtn = $("#checkoutBtn");
  if (checkoutBtn) checkoutBtn.addEventListener("click", e => {
    let t; try { t = localStorage.getItem("zt-box-tier"); } catch (err) { return; }
    const codes = { 2: "ZTBOX10", 3: "ZTBOX15", 4: "ZTBOX20" };
    if (t && codes[t]) {
      e.preventDefault();
      location.href = `/discount/${codes[t]}?redirect=%2Fcheckout`;
    }
  });

  /* ---------- PDP ---------- */
  const pdpRoot = $("#pdpRoot");
  if (pdpRoot) {
    const thumbs = $("#pdpThumbs"), mainImg = $("#pdpMainImg");
    if (thumbs && mainImg) {
      thumbs.addEventListener("click", e => {
        const b = e.target.closest("button"); if (!b) return;
        $$("button", thumbs).forEach(x => x.classList.toggle("active", x === b));
        mainImg.src = b.dataset.src;
        if (b.dataset.type === "life") {
          mainImg.style.cssText = "height:100%;width:100%;object-fit:cover;filter:none;animation:none;border-radius:0";
        } else {
          mainImg.style.cssText = "";
        }
      });
    }

    const buyForm = $("#pdpBuyForm");
    if (buyForm) {
      const addBtn = $("#pdpAdd");
      const unit = +addBtn.dataset.price; /* cents */
      let qty = 1;
      const setQty = v => {
        qty = Math.max(1, Math.min(9, v));
        $("#qVal").textContent = qty;
        $("#qInput").value = qty;
        $("#pdpAddPrice").textContent = moneyCents(unit * qty);
      };
      $("#qMinus").onclick = () => setQty(qty - 1);
      $("#qPlus").onclick = () => setQty(qty + 1);
      buyForm.addEventListener("submit", e => {
        e.preventDefault();
        addToCart(+buyForm.querySelector('[name="id"]').value, qty).then(() => openCart(true));
      });
    }

    $$(".acc-item").forEach(item => {
      const head = $(".acc-head", item), body = $(".acc-body", item);
      if (!head || !body) return;
      if (item.classList.contains("open")) body.style.maxHeight = body.scrollHeight + "px";
      head.addEventListener("click", () => {
        const open = item.classList.toggle("open");
        body.style.maxHeight = open ? body.scrollHeight + "px" : "0";
      });
    });

    const stickyBuy = $("#stickyBuy");
    if (stickyBuy) addEventListener("scroll", () => {
      stickyBuy.classList.toggle("show", scrollY > 480);
    }, { passive: true });
  }

  refreshCart();
})();
